import classNames from 'classnames';
import PropTypes from 'prop-types';
import Styles from './BlogPostHero.module.scss';

const BlogPostHero = ({ children, title, date, excerpt, featuredImage, ...props }) => {
  return (
    <div className={classNames(Styles.container, !featuredImage && Styles.hasNoImage)} {...props}>
      <div className={Styles.textContent}>
        <p className={Styles.date}>{date}</p>
        <h1
          className={Styles.title}
          dangerouslySetInnerHTML={{
            __html: title,
          }}></h1>
        <p
          className={Styles.paragraph}
          dangerouslySetInnerHTML={{
            __html: excerpt,
          }}></p>
      </div>

      {featuredImage && (
        <div className={Styles.imageContainer}>
          <img className={Styles.featuredImage} src={featuredImage} alt={title} loading='lazy' />
        </div>
      )}
    </div>
  );
};

BlogPostHero.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  excerpt: PropTypes.string,
  featuredImage: PropTypes.string,
};

export default BlogPostHero;
